import { is } from '@common/is/is'

import styles from './AuthInput.css'

interface IProps {
  readonly title?: string
  readonly name?: string
  readonly type: 'password' | 'text' | 'submit'
}

/**
 * Input elem factory-ja, vagy submit gomb, vagy beviteli mezőként.
 * @param props - JSX props {@link IProps}.
 */
export default function AuthInput (props: IProps): HTMLInputElement {
  const isSubmit = props.type === 'submit'
  const Element = isSubmit ? 'button' : 'input'

  // @ts-expect-error Legacy.
  const input: HTMLInputElement | HTMLButtonElement = <Element type={ props.type } />

  if (props.name) {
    input.name = props.name
  }

  if (isSubmit) {
    input.classList.add(styles.submit)
    input.innerHTML = 'Bejelentkezés'
  }
  else if (is.instanceOf(input, HTMLInputElement)) {
    input.classList.add(styles.input)
    input.spellcheck     = false
    input.placeholder    = props.type === 'password' ? 'Jelszó' : 'Felhasználónév'
    input.autocomplete   = 'on'
    input.autocapitalize = 'off'
  }

 /**
  * Szemre kattintva megmutatjuk a password részt, vagy eltűntetjük.
  * @param e - A klikk esemény.
  */
  function onClickEye (e: Event): void {
    const eye         = e.currentTarget as HTMLElement
    const inputType   = input.getAttribute('type')
    const reverseType = inputType === 'name' ? 'password' : 'name'

    input.setAttribute('type', reverseType)

    const isOpen = reverseType === 'name'
    eye.setAttribute('data-open', `${ isOpen }`)
  }

  const eye = props.type === 'password'
    ? <div className={ styles.eye } onClick={ onClickEye } />
    : null

  return (
    <div className={ styles.block }>
      { input }
      { eye }
    </div>
  )
}
